import React, { useState, useEffect, useRef } from "react";
import Footer from "../Footer/Footer";
import NewHeader from "../NewHeader/NewHeader";
import SubFooter from "../SubFooter/SubFooter";
import LoginCarousel from "./LoginCarousel"
import ScrolltoTop from "../Scrolltotop/ScrolltoTop";
import { FaEye } from 'react-icons/fa';
import { FaEyeSlash } from 'react-icons/fa';
import "./Login.css";
import google from "../../Assets/google.png";
import facebook from "../../Assets/facebook.png";

function NewSignUp(){
  	const [name, setName] = useState("");
  	const [email, setEmail] = useState("");
  	const [age, setAge] = useState("");
  	const [gender, setGender] = useState("");
  	const [nameErr, setNameErr] = useState("");
  	const [ageErr, setAgeErr] = useState("");
  	const [genderErr, setGenderErr] = useState("");
  	const [emailErr, setEmailErr] = useState("");
  	
  	const initailValue = {
	    name: "",
	    age:"",
	    gender: "",
	    email: "",
	};
  	const [newSignUpFormValue, setNewSignUpFV] = useState(initailValue);


	const ChangePasswordSubmit = (e) => {
		e.preventDefault();
	    console.log(newSignUpFormValue, "form valueeee");
	    if (
	      newSignUpFormValue.name != "" &&
	      newSignUpFormValue.age != "" &&
	      newSignUpFormValue.gender != "" &&
	      newSignUpFormValue.email != ""
	    ) {
	      console.log("new signup form", newSignUpFormValue);
	    } else {
	      if (name == "") {
	        setNameErr("Name is required.");
	      }
	      if (email == "") {
	        setEmailErr("Email is required.");
	      }
	      if (age == "") {
	        setAgeErr("Age is required.");
	      }
	      if (gender == "") {
	        setGenderErr("Gender is required.");
	      }
	    }
	}
	
	const handleNameChange = (e) => {
		setName(e.target.value);
    	const { name, value } = e.target;
		const characterRegex =/^([A-Za-z]+[ ]?)+$/;
    	setNameErr("");
		if (!e.target.value.match(characterRegex)) {
	      	setNameErr("Invalid user name");
      		setNewSignUpFV({ ...newSignUpFormValue, [name]: "" });
	    } else {
    		setNameErr("");
      		setNewSignUpFV({ ...newSignUpFormValue, [name]: value });
	    }
	    if (e.target.value == "") {
	      	setNameErr("");
      		setNewSignUpFV({ ...newSignUpFormValue, [name]: "" });
	    }
	}
	const handleEmailChange = (e) => {
		setEmail(e.target.value);
    	const { name, value } = e.target;
		const regex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
	    if (!e.target.value) {
	      	setEmailErr("Email is required.");
      		setNewSignUpFV({ ...newSignUpFormValue, [name]: "" });
	    }
	    if (!regex.test(e.target.value)) {
	      	setEmailErr("This is not a valid Email Format");
      		setNewSignUpFV({ ...newSignUpFormValue, [name]: "" });

	    } else {
	      	setEmailErr("");
      		setNewSignUpFV({ ...newSignUpFormValue, [name]: value });
	    }
	    if (e.target.value == "") {
	      	setEmailErr("");
      		setNewSignUpFV({ ...newSignUpFormValue, [name]: "" });
	    }
	}
	const handleAgeChange = (e) => {
		setAge(e.target.value);
    	const { name, value } = e.target;
	    if (e.target.value <= 0 || e.target.value >= 104) {
	      	setAgeErr("Age is required greater than 0 and less than 104 years");
	      	setNewSignUpFV({ ...newSignUpFormValue, [name]: "" });
	    } else if (e.target.value.includes("-")) {
	      	setAgeErr("Not a valid age");
	      	setNewSignUpFV({ ...newSignUpFormValue, [name]: "" });
	    } else {
	      	setAgeErr("");
	      	setNewSignUpFV({ ...newSignUpFormValue, [name]: value });
	    }
	    if (e.target.value == "") {
	      	setAgeErr("");
	    }
	}
	const handleGenderChange = (e) => {
		setGender(e.target.value);
		const { name, value } = e.target;
	    if (!e.target.value) {
	      	setGenderErr("Gender is required.");
	      	setNewSignUpFV({ ...newSignUpFormValue, [name]: "" });
	    } else {
	      	setNewSignUpFV({ ...newSignUpFormValue, [name]: value });
	      	setGenderErr("");
	    }
	    if (e.target.value == "") {
	      	setGenderErr("");
	    }
	}
	
	return(
		<>
      		<NewHeader />
      		<div className="loginMainHeading">
		        <h1>Welcome To Redcliffe Labs! </h1>
		    </div>
      		<div className="loginNewContent">
      			<div className="loginNewFormDiv">
      				<div className="CarouselDivOfLogin">
      					<LoginCarousel />
      				</div>
      				<form
			            className="NewSignUp-form login-form"
			            onSubmit={ChangePasswordSubmit}
			        >
			        	<h2>Enter your Details</h2>
			            <p className="Loginpara">Name</p>
			            <div className="PasswordInputAdd PasswordChngDiv">
				            <input
				            	type="text"
				              	onChange={handleNameChange}
				              	value={name}
				              	placeholder="Enter Name"
				              	name="name"
				              	className="password-field"
				            ></input>
				            <span
			                  style={{
			                    color: "red",
			                    marginBottom: "10px",
			                    fontSize: "13px",
			                    bottom: "-20px",
			                  }}
			                >
			                  {nameErr}
			                </span>
				        </div>
			            <p className="Loginpara">Email</p>
			            <div className="PasswordInputAdd">
				            <input
				            	type="email"
				              	onChange={handleEmailChange}
				              	value={email}
				              	placeholder="Enter Email"
				              	name="email"
				              	className="password-field"
				            ></input>
				            <span
			                  style={{
			                    color: "red",
			                    marginBottom: "10px",
			                    fontSize: "13px",
			                    bottom: "-20px",
			                  }}
			                >
			                  {emailErr}
			                </span>
				        </div>
				        <div className="AgeGenderDivv">
				        	<div className="AgeInputDiv">
				        		<p className="Loginpara">Age</p>
					            <div className="PasswordInputAdd">
						            <input
						            	type="number"
						              	onChange={handleAgeChange}
						              	value={age}
						              	placeholder="Enter Age"
						              	name="age"
						              	className="password-field"
						            ></input>
						            <span
					                  style={{
					                    color: "red",
					                    marginBottom: "10px",
					                    fontSize: "13px",
					                    bottom: "-20px",
					                  }}
					                >
					                  {ageErr}
					                </span>
						        </div>
				        	</div>
				        	<div className="GenderInputDiv">
				        		<p className="Loginpara">Gender</p>
				        		<input type="radio" value="Male" placeholder="Male" name="gender" onChange={handleGenderChange} /><span className="genderName maleGenderSpan">Male</span>
				        		<input type="radio" value="Female" placeholder="Female" name="gender" onChange={handleGenderChange} /><span className="genderName">Female</span>
				        		<p
				                  style={{
				                    color: "red",
				                    marginBottom: "10px",
				                    fontSize: "13px",
				                    bottom: "-20px",
				                  }}
				                >
				                  {genderErr}
				                </p>
				        	</div>
				        </div>
			            <button className="Login__submit">
			              <span className="btn">Update Details</span>
			            </button>
			        </form>
      			</div>
      		</div>
      		<Footer />
		</>
	)
}
export default {
  component: NewSignUp,
};
